import { render, staticRenderFns } from "./index_edit.vue?vue&type=template&id=135753d3&scoped=true"
import script from "./index_edit.vue?vue&type=script&lang=js"
export * from "./index_edit.vue?vue&type=script&lang=js"
import style0 from "./index_edit.vue?vue&type=style&index=0&id=135753d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135753d3",
  null
  
)

export default component.exports